import React from 'react';

import { ArrowLeft } from '@zoomit/icons';
import { mapLinkHandler, mapsUrl } from '@zoomit/web-kit';

interface MapLinkProps {
  latitude: number | string;
  longitude: number | string;
  label: string | undefined;
}

const MapLink: React.FC<MapLinkProps> = ({ latitude, longitude, label }) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    mapLinkHandler({
      latitude: String(latitude),
      longitude: String(longitude),
      label: label ?? '',
    });
  };

  return (
    <a
      href={mapsUrl({ latitude: String(latitude), longitude: String(longitude) })}
      onClick={handleClick}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`نمایش ${label ?? ''} در نقشه`}
      className="bg-primary1 hover:bg-primary2 flex h-fit w-full items-center justify-center gap-2 rounded-full px-4 py-3 leading-2 text-white transition-colors md:w-fit"
    >
      مشاهده روی نقشه
      <ArrowLeft className="fill-white" size="sm" />
    </a>
  );
};

export default MapLink;
